import React from "react";
import AddContractorsAndVendors from "../../Operations/AddContractorsAndVendors";
import { ContractorsListComp } from "../../Operations/Contractors/Contractors/Contractors";
import AddWorkOrders from "../../Operations/Contractors/WorkOrders/AddWorkOrders";
import WorkOrderDetailsPage from "../../Operations/Contractors/WorkOrders/WorkOrderDetailsPage";
import { WorkOrdersListComp } from "../../Operations/Contractors/WorkOrders/WorkOrders";
import WorksDashboard from "../../Operations/Works/WorksDashboard";
import ContractorBills from "../../Operations/Works/ContractorBills";
import ContractorBillForm from "../../Operations/Contractors/WorkOrders/ContractorBillForm";
import BOQTable from "../../Operations/Works/BOQ/BOQTable";
import BOQForm from "../../Operations/Works/BOQ/BOQForm";
import RateLibrary from "../../Operations/Works/RateLibrary/RateLibrary";
import RateLibraryForm from "../../Operations/Works/RateLibrary/RateLibraryForm";
import MeasurementTable from "../../Operations/Works/MeasurementBook/MeasurementTable";
import MeasurementBookForm from "../../Operations/Works/MeasurementBook/MeasurementBookForm";
import WorkOrderExecutionProgressReport from "../../Operations/Works/Reports/WorkOrderExecutionProgressReport";
import SubcontractorRABillRegisterReport from "../../Operations/Works/Reports/SubcontractorRABillRegisterReport";
import MeasurementBookAuditRegisterReport from "../../Operations/Works/Reports/MeasurementBookAuditRegisterReport";
import SubcontractorRetentionLedgerReport from "../../Operations/Works/Reports/SubcontractorRetentionLedgerReport";
import AdvanceRecoveryStatementReport from "../../Operations/Works/Reports/AdvanceRecoveryStatementReport";
import SubcontractorPayablesAgingReport from "../../Operations/Works/Reports/SubcontractorPayablesAgingReport";

// TODO: Once Works permissions are introduced, replace the temporary Work Orders
// role used by the dashboard and remove the legacy Store route compatibility layer.
// Dedicated Works URLs. Existing Store URLs remain registered for backwards
// compatibility while the module menus are being separated.
export const worksRoutes = [
  {
    path: "/works/dashboard",
    component: <WorksDashboard />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/works/contractors",
    component: <ContractorsListComp />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/contractors/add",
    component: <AddContractorsAndVendors />,
    rolename: "Store Contractors_Create",
  },
  // Bill of Quantities (BOQ)
  {
    path: "/works/bill-of-quantities",
    component: <BOQTable />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/bill-of-quantities/add",
    component: <BOQForm />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/bill-of-quantities/edit/:id",
    component: <BOQForm />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/bill-of-quantities/details/:id",
    component: <BOQForm />,
    rolename: "Store Contractors_View",
  },
  // Legacy BOQ routes for backwards compatibility
  {
    path: "/works/boq",
    component: <BOQTable />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/boq/bill-of-quantities",
    component: <BOQTable />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/boq/bill-of-quantities/add",
    component: <BOQForm />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/boq/bill-of-quantities/edit/:id",
    component: <BOQForm />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/boq/bill-of-quantities/details/:id",
    component: <BOQForm />,
    rolename: "Store Contractors_View",
  },
  // Rate Library
  {
    path: "/works/rate-library",
    component: <RateLibrary />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/rate-library/add",
    component: <RateLibraryForm />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/rate-library/edit/:id",
    component: <RateLibraryForm />,
    rolename: "Store Contractors_View",
  },
  // Legacy Rate Library routes for backwards compatibility
  {
    path: "/works/boq/rate-library",
    component: <RateLibrary />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/boq/rate-library/add",
    component: <RateLibraryForm />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/boq/rate-library/edit/:id",
    component: <RateLibraryForm />,
    rolename: "Store Contractors_View",
  },
  // Measurement Book
  {
    path: "/works/measurement-book",
    component: <MeasurementTable />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/works/measurement-book/add",
    component: <MeasurementBookForm />,
    rolename: "Store Work Orders_View",
  },
  // Legacy Measurement Book routes
  {
    path: "/works/work-orders/measurement-book",
    component: <MeasurementTable />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/work-orders/measurement-book/add",
    component: <MeasurementBookForm />,
    rolename: "Store Contractors_View",
  },
  // Work Orders
  {
    path: "/works/work-orders",
    component: <WorkOrdersListComp />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/work-orders/add",
    component: <AddWorkOrders />,
    rolename: "Store Contractors_View",
  },
  {
    path: "/works/work-orders/details/:id",
    component: <WorkOrderDetailsPage />,
    rolename: "Store Contractors_View",
  },
  // Legacy /wo aliases for Work Orders
  {
    path: "/works/work-orders/wo",
    component: <WorkOrdersListComp />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/works/work-orders/wo/add",
    component: <AddWorkOrders />,
    rolename: "Store Work Orders_Create",
  },
  {
    path: "/works/work-orders/wo/details/:id",
    component: <WorkOrderDetailsPage />,
    rolename: "Store Work Orders_View",
  },
  // Contractor Bills
  {
    path: "/works/contractor-bills",
    component: <ContractorBills />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/works/contractor-bills/add/:workOrderId?",
    component: <ContractorBillForm />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/works/contractor-bills/add",
    component: <ContractorBillForm />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/works/work-orders/bills/add/:workOrderId?",
    component: <ContractorBillForm />,
    rolename: "Store Work Orders_View",
  },
  // Legacy alias for Contractor Bills
  {
    path: "/works/work-orders/contractor-bills",
    component: <ContractorBills />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/works/reports",
    component: <WorkOrderExecutionProgressReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/works/reports/wo-progress",
    component: <WorkOrderExecutionProgressReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/works/reports/ra-bills",
    component: <SubcontractorRABillRegisterReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/works/reports/mb-audit",
    component: <MeasurementBookAuditRegisterReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/works/reports/retention-ledger",
    component: <SubcontractorRetentionLedgerReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/works/reports/advance-recovery",
    component: <AdvanceRecoveryStatementReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/works/reports/contractor-aging",
    component: <SubcontractorPayablesAgingReport />,
    rolename: "Store Dashboard_View",
  },
];
